import {
  getDashboardStatisticActionType, StatisticActionTypes, getLiveStatisticActionType,
} from '../../model/statistic/actions';
import { StatResult, StatLiveResult } from '../../model/statistic/types';
import { createActions } from '../../helpers/actionsHelper';

export class DateRange {
  startDate: string;
  endDate: string | undefined;
  constructor(start:string, end:string | undefined) {
    this.startDate = start;
    this.endDate = end;
  }
}
export const getDashboardStatisticAction = createActions<StatisticActionTypes, DateRange, StatResult>(getDashboardStatisticActionType);

export const getLiveStatisticAction = createActions<StatisticActionTypes, DateRange, StatLiveResult>(getLiveStatisticActionType);